// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label[data-v-758ca39a] {\n  font-size: 12px;\n  color: #999;\n}\n.slider-box[data-v-758ca39a] {\n  width: 81%;\n}\n[data-v-758ca39a] .el-cascader__search-input {\n  background-color: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
